import { Text } from '@/components/ui/text';
import { View } from 'react-native';
import { DatePicker } from '@/components/date-picker/DatePicker';
import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { useHistoryMinDate } from '~/calendar/hooks/useHistoryMinDate';

export interface StandardHeaderProps {
  subtitle: string;
  title: string;
  children?: ReactNode;
  className?: string;
}

export interface StandardHeaderDateProps {
  currentDate: Date;
  onDateChange?: (date: Date) => void;
  /**
   * Earliest selectable date (inclusive). Defaults to the current user's history
   * window (Free = last 30 days via {@link useHistoryMinDate}, entitled = unbounded);
   * pass an explicit value to override.
   */
  minimumDate?: Date;
  className?: string;
}

const StandardHeaderDate = ({
  currentDate,
  onDateChange,
  minimumDate,
  className,
}: StandardHeaderDateProps) => {
  const historyMinDate = useHistoryMinDate();
  return (
    <DatePicker
      variant="pill"
      value={currentDate}
      onChange={(date) => onDateChange?.(date)}
      minimumDate={minimumDate ?? historyMinDate ?? undefined}
      className={className}
    />
  );
};

export const StandardHeader = ({
  subtitle,
  title,
  children,
  className,
}: StandardHeaderProps) => {
  return (
    <View
      className={cn(
        className,
        'w-full flex flex-row gap-2 justify-between items-center',
      )}
    >
      <View className="flex flex-col">
        <Text className="font-inter-regular text-sm text-text-secondary">
          {subtitle}
        </Text>
        <Text className="font-sora-bold text-2xl text-text-primary tracking-tight">
          {title}
        </Text>
      </View>
      {children}
    </View>
  );
};

StandardHeader.Date = StandardHeaderDate;
